var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClearIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#697077",
  d: "M12.707 4.706a1.001 1.001 0 0 0-1.416-1.415l-3.29 3.293-3.294-3.29A1.002 1.002 0 0 0 3.29 4.709L6.585 8l-3.29 3.295a1.002 1.002 0 0 0 1.415 1.415L8 9.416l3.294 3.29a1.002 1.002 0 0 0 1.416-1.415L9.416 8l3.29-3.294Z"
})));
export default SvgClearIcon;